package com.patronat.top.features.dashboard.presentation.ownerreviews

import com.patronat.top.core.base.ViewEvent
import com.patronat.top.core.base.ViewSideEffect
import com.patronat.top.core.base.ViewState
import com.patronat.top.dto.ReviewResponse

data class OwnerReviewsState(
    val reviews: List<ReviewResponse> = emptyList(),
    val venueNamesById: Map<String, String> = emptyMap(),
    val failedVenueIds: Set<String> = emptySet(),
    val totalCount: Long = 0,
    val currentPage: Int = 1,
    val pageSize: Int = 20,
    val isLoading: Boolean = true,
    val replyingReviewId: String? = null,
    val replyDrafts: Map<String, String> = emptyMap(),
    val searchQuery: String = "",
    val error: String? = null
) : ViewState {
    val isEmpty: Boolean
        get() = reviews.isEmpty() && !isLoading && error == null
}

sealed interface OwnerReviewsEvent : ViewEvent {
    data object Initialize : OwnerReviewsEvent
    data object OnReload : OwnerReviewsEvent
    data class OnSearchChanged(val query: String) : OwnerReviewsEvent
    data class OnPageChanged(val page: Int) : OwnerReviewsEvent
    data class OnPageSizeChanged(val pageSize: Int) : OwnerReviewsEvent
    data class OnReplyChanged(val reviewId: String, val text: String) : OwnerReviewsEvent
    data class OnSendReplyClicked(val reviewId: String) : OwnerReviewsEvent
}

sealed interface OwnerReviewsEffect : ViewSideEffect
